import { Card, CardBody, Col, Row } from "reactstrap";
import { OutlineAlertTitle } from "../../../../Constants/Constants";
import { OutlineAlertSubTitle } from "../../../../Data/UiKits/Alert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DarkOutline from "./DarkOutline";
import LightOutline from "./LightOutline";
import DoubleOutline from "./DoubleOutline";
import InsetOutline from "./InsetOutline";

const OutlineAlert = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={OutlineAlertTitle} span={OutlineAlertSubTitle} />
        <CardBody className="outline-alerts">
          <Row className="gy-3">
            <Col xl="6">
              <LightOutline />
              <DarkOutline />
            </Col>
            <Col xl="6">
              <DoubleOutline />
              <InsetOutline />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default OutlineAlert;
